import Axios from 'axios';
import { useAuthStore } from '@store/useAuthStore';

// NestJS API 기본 URL — accessToken은 NestJS가 발급/갱신하며, 갤러리 서버는 같은
// JWT_SECRET으로 검증만 할 뿐 자체 로그인/갱신 엔드포인트가 없다
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:7070';

// 진행 중인 갱신 요청 — NestJS/갤러리 두 axios 인스턴스가 동시에 401을 만나도
// 갱신 요청은 한 번만 나가고 나머지 호출은 같은 Promise 결과를 그대로 재사용한다
let inFlightRefresh: Promise<string> | null = null;

export const refreshAccessToken = (): Promise<string> => {
	if (!inFlightRefresh) {
		inFlightRefresh = Axios.post(`${API_BASE_URL}/v1/admins/refresh`, {}, { withCredentials: true })
			.then((response) => {
				const { accessToken } = response.data as { accessToken: string };
				useAuthStore.getState().setAccessToken(accessToken);
				return accessToken;
			})
			.finally(() => {
				inFlightRefresh = null;
			});
	}
	return inFlightRefresh;
};
